import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 
 */
export class HomeControllerSvr {
    constructor() {
        this.baseurl = 'HomeControllerSvr.assx/';
    }

    /**
     * 项目经理 首页 小区信息
     * token:String, evaluateObjType:int, eaAreaCode:String
     */
    GetEaAreaInfo(token, evaluateObjType, eaAreaCode) {
        return request.post(this.baseurl + 'GetEaAreaInfo', Qs.stringify({
            token: token,
            evaluateObjType: evaluateObjType,
            eaAreaCode: eaAreaCode
        }));
    }

    /**
     * 未读消息总数(option:0 未读，1 已读)
     * token:String, option:int
     */
    getMessageCount(token, option) {
        return request.post(this.baseurl + 'getMessageCount', Qs.stringify({
            token: token,
            option: option
        }));
    }

    /**
     * 快捷入口列表
     * token:String
     */
    GetQuickPointList(token) {
        return request.post(this.baseurl + 'GetQuickPointList', Qs.stringify({
            token: token
        }));
    }

    /**
     * getCantonEvaluteStat
     * token:String, year:int, month:int, type:int
     */
    getCantonEvaluteStat(token, year, month, type) {
        return request.post(this.baseurl + 'getCantonEvaluteStat', Qs.stringify({
            token: token,
            year: year,
            month: month,
            type: type
        }));
    }

    /**
     * 设置物业企业的总公司机构代码
     * token:String, headOffice:String
     */
    setHeadOffice(token, headOffice) {
        return request.post(this.baseurl + 'setHeadOffice', Qs.stringify({
            token: token,
            headOffice: headOffice
        }));
    }

    /**
     * 首页口碑物业模块信息
     * token:String
     */
    GetEvaluteProfile(token) {
        return request.post(this.baseurl + 'GetEvaluteProfile', Qs.stringify({
            token: token
        }));
    }

    /**
     * 菜单权限
     * token:String, right:String, subRight:String
     */
    GetRight(token, right, subRight) {
        return request.post(this.baseurl + 'GetRight', Qs.stringify({
            token: token,
            right: right,
            subRight: subRight
        }));
    }

    /**
     * 我的已发信息
     * token:String, page:int, rows:int, order:String, isread:int, keyWord:String
     */
    AjaxMySendedTidingsList(token, page, rows, order, isread, keyWord) {
        return request.post(this.baseurl + 'AjaxMySendedTidingsList', Qs.stringify({
            token: token,
            page: page,
            rows: rows,
            order: order,
            isread: isread,
            keyWord: keyWord
        }));
    }

    /**
     * 首页市/区物业区域概况
     * token:String
     */
    GetEaAreaGenSit(token) {
        return request.post(this.baseurl + 'GetEaAreaGenSit', Qs.stringify({
            token: token
        }));
    }

    /**
     * 待办/已办事项info
     * token:String, keyid:String
     */
    GetAffairInfo(token, keyid) {
        return request.post(this.baseurl + 'GetAffairInfo', Qs.stringify({
            token: token,
            keyid: keyid
        }));
    }

    /**
     * 获取用户拥有的权限
     * token:String, loginId:String, option:int
     */
    GetUserRightList(token, loginId, option) {
        return request.post(this.baseurl + 'GetUserRightList', Qs.stringify({
            token: token,
            loginId: loginId,
            option: option
        }));
    }

    /**
     * 工作info
     * token:String, docCode:String, body:boolean
     */
    GetBusinessDocInfo(token, docCode, body) {
        return request.post(this.baseurl + 'GetBusinessDocInfo', Qs.stringify({
            token: token,
            docCode: docCode,
            body: body
        }));
    }

    /**
     * 我的工作
     * token:String, page:Integer, rows:Integer, order:String, keyWord:String
     */
    GetMyWorkList(token, page, rows, order, keyWord) {
        return request.post(this.baseurl + 'GetMyWorkList', Qs.stringify({
            token: token,
            page: page,
            rows: rows,
            order: order,
            keyWord: keyWord
        }));
    }

    /**
     * (description="我的 已读/未读消息 ( isread 0  未读  1  已读) ")
     * token:String, page:int, rows:int, order:String, isread:int, keyWord:String
     */
    AjaxMyTidingsList(token, page, rows, order, isread, keyWord) {
        return request.post(this.baseurl + 'AjaxMyTidingsList', Qs.stringify({
            token: token,
            page: page,
            rows: rows,
            order: order,
            isread: isread,
            keyWord: keyWord
        }));
    }

    /**
     * 我的待办/已办事项
     * token:String, page:int, rows:int, order:String, isrunned:int, keyWord:String
     */
    GetMyAffairsList(token, page, rows, order, isrunned, keyWord) {
        return request.post(this.baseurl + 'GetMyAffairsList', Qs.stringify({
            token: token,
            page: page,
            rows: rows,
            order: order,
            isrunned: isrunned,
            keyWord: keyWord
        }));
    }

    /**
     * 首页事项列表
     * token:String
     */
    GetHomeAffairlist(token) {
        return request.post(this.baseurl + 'GetHomeAffairlist', Qs.stringify({
            token: token
        }));
    }

    /**
     * 检查物业企业是否绑定总公司
     * token:String
     */
    checkIsHeadOffice(token) {
        return request.post(this.baseurl + 'checkIsHeadOffice', Qs.stringify({
            token: token
        }));
    }

    /**
     * 消息详情
     * token:String, id:String
     */
    ShowTidings(token, id) {
        return request.post(this.baseurl + 'ShowTidings', Qs.stringify({
            token: token,
            id: id
        }));
    }

    /**
     * 快捷入口点击添加
     * token:String, menuName:String, oper:String
     */
    RecordQuickPoint(token, menuName, oper) {
        return request.post(this.baseurl + 'RecordQuickPoint', Qs.stringify({
            token: token,
            menuName: menuName,
            oper: oper
        }));
    }
}